import { Link } from "react-router-dom";
import { MapPin, Star, BadgeCheck } from "lucide-react";
import StarRating from "@/components/StarRating";

export default function RestaurantCard({ r, index = 0 }) {
  return (
    <Link
      to={`/directory/${r.id}`}
      data-testid={`restaurant-card-${r.id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 70, 600)}ms` }}
    >
      <div className="img-zoom aspect-[4/5] bg-sand-100 mb-5 relative">
        <img
          src={r.cover_image}
          alt={r.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <span className="absolute top-4 left-4 bg-sand-50 px-3 py-1 font-mono text-[10px] tracking-[0.2em] uppercase">
          {r.category}
        </span>
        <span className="absolute top-4 right-4 bg-sand-900/80 text-sand-50 px-2 py-1 font-mono text-[10px] flex items-center gap-1">
          <Star size={10} className="fill-ochre-400 text-ochre-400" />
          {r.rating?.toFixed(1)}
        </span>
        {r.verified && (
          <span className="absolute bottom-4 left-4 bg-brand-500 text-sand-50 px-2 py-1 font-mono text-[9px] tracking-[0.15em] uppercase flex items-center gap-1" data-testid={`verified-badge-${r.id}`}>
            <BadgeCheck size={11} /> Verified
          </span>
        )}
      </div>
      <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-brand-500 mb-2">
        {r.cuisine} · {r.price_range}
      </div>
      <h3 className="font-serif text-2xl md:text-3xl font-bold text-sand-900 leading-tight group-hover:text-brand-500 transition-colors flex items-center gap-2">
        {r.name}
        {r.verified && <BadgeCheck size={18} className="text-brand-500 shrink-0" />}
      </h3>
      <div className="mt-2 flex items-center gap-1.5 text-sand-700 text-sm">
        <MapPin size={13} />
        <span>{r.neighborhood}{r.city ? ` · ${r.city}` : ""}</span>
      </div>
      {r.review_count > 0 && (
        <div className="mt-2 flex items-center gap-2" data-testid={`card-community-rating-${r.id}`}>
          <StarRating value={r.community_rating} size={14} />
          <span className="font-mono text-[11px] text-sand-700">
            {r.community_rating.toFixed(1)} · {r.review_count} {r.review_count === 1 ? "review" : "reviews"}
          </span>
        </div>
      )}
      <p className="mt-3 text-sand-700 text-sm font-light leading-relaxed line-clamp-2">
        {r.short_description}
      </p>
    </Link>
  );
}
